
import { apiCall, ApiResponse } from "./apiClient";
import { VehicleMaintenanceDto } from "../models/vehicle/vehicleMaintenance";

export const saveVehicleMaintenance = async (
    vehicleMaintenance: VehicleMaintenanceDto,
    signal?: AbortSignal): Promise<ApiResponse<VehicleMaintenanceDto>> => {

    const isNew = !vehicleMaintenance.id ? true : false;

    return apiCall<VehicleMaintenanceDto>(
        "vehiclemaintenance",
        isNew ? "PUT" : "POST",
        vehicleMaintenance,
        signal);
};

export const deleteVehicleMaintenance = async (
    vehicleMaintenanceId: string,
    signal?: AbortSignal): Promise<ApiResponse<void>> => {

    return apiCall<void>(
        `vehiclemaintenance/${vehicleMaintenanceId}`,
        "DELETE",
        undefined,
        signal);
};

export const getVehicleMaintenances = async (
    fromDate: Date,
    untilDate?: Date,
    vehicleIds?: string[],
    signal?: AbortSignal) => {

    // Format dates as YYYY-MM-DD for DateOnly backend parameter
    const formatDateOnly = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fromDateStr = formatDateOnly(fromDate);
    const untilDateStr = untilDate ? formatDateOnly(untilDate) : null;

    const response = await apiCall<VehicleMaintenanceDto[]>("vehiclemaintenance?fromDate=" + fromDateStr + (untilDateStr ? "&untilDate=" + untilDateStr : "") + (vehicleIds ? "&vehicleIds=" + vehicleIds.join(",") : ""), "GET", signal);
    return response.data;
};
